import { Modal } from "components";

import { LocationGenerics } from "router/location";
import UpdateSlipWizardContainer from "components/forms/slip-wizard/update";
import { useOffer } from "hooks/data/use-offers";
import { useSearch } from "react-location";

export { validationSchema } from "components/forms/slip-wizard/validation";

export default function UpdateOfferContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const { loading: fetching, offer } = useOffer({
        offer_id: searchParams.id || "",
    });

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            size="4xl"
            loading={fetching}
            hideActions
            title="Update Offer"
            description="Provide the details to update offer">
            <UpdateSlipWizardContainer
                setClose={setOpen}
                refetch={refetch}
                offer={offer}
                offerId={searchParams.id}
            />
        </Modal>
    );
}
